"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdentificationNumberType = void 0; //is this a prblem? not using the types in @upsolve/shared

var IdentificationNumberType;

(function (IdentificationNumberType) {
  IdentificationNumberType["EIN"] = "ein";
  IdentificationNumberType["ITIN"] = "itin";
  IdentificationNumberType["SSN"] = "ssn";
  IdentificationNumberType["A_NUMBER"] = "a_number";
  IdentificationNumberType["TRAVEL_DOCUMENT_NUMBER"] = "travel_document_number";
  IdentificationNumberType["PASSPORT_NUMBER"] = "passport_number";
  IdentificationNumberType["I94_ARRIVAL_DEPARTURE_RECORD_NUMBER"] = "i94_arrival_departure_record_number";
  IdentificationNumberType["USCIS_ONLINE_ACCOUNT_NUMBER"] = "uscis_online_account_number";
  IdentificationNumberType["STUDENT_AND_EXCHANGE_VISITOR_NUMBER"] = "student_and_exchange_visitor_number";
})(IdentificationNumberType = exports.IdentificationNumberType || (exports.IdentificationNumberType = {}));